const sleep = (ms: number) => new Promise((resolve, _) => setTimeout(resolve, ms));

export default sleep;
